import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TestTube, ArrowRight, ExternalLink } from "lucide-react";

const PaymentLinkingTest = () => {
  const navigate = useNavigate();
  const [linkCode, setLinkCode] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (linkCode.trim()) {
      navigate(`/b2b/linking/${linkCode.trim()}`);
    }
  };

  const handleQuickTest = (code) => {
    navigate(`/b2b/linking/${code}`);
  };

  const testCodes = [
    { code: "HW2NXAHXYK7L", label: "One-Time Payment", description: "Test one-time credit card payment" },
    { code: "ULUPDRXXQDBN", label: "Recurring Payment", description: "Test recurring payment with save card" },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        {/* Header */}
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-6 text-center">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <TestTube className="w-8 h-8 text-green-600" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Payment Linking Test</h1>
          <p className="text-gray-500">Enter a payment link code to test</p>
        </div>

        {/* Input Form */}
        <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-lg p-6 mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">Payment Link Code</label>
          <input
            type="text"
            value={linkCode}
            onChange={(e) => setLinkCode(e.target.value.toUpperCase())}
            placeholder="Enter link code (e.g., ABC123XYZ)"
            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent uppercase"
          />
          <button
            type="submit"
            disabled={!linkCode.trim()}
            className="w-full mt-4 bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 disabled:from-gray-400 disabled:to-gray-500 text-white font-semibold py-3 px-6 rounded-xl shadow-lg hover:shadow-xl transition-all flex items-center justify-center"
          >
            Test Payment Link
            <ArrowRight className="w-5 h-5 ml-2" />
          </button>
        </form>

        {/* Quick Test Links */}
        <div className="bg-white rounded-2xl shadow-lg p-6">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Quick Test Links</h2>
          <div className="space-y-3">
            {testCodes.map((test) => (
              <button
                key={test.code}
                onClick={() => handleQuickTest(test.code)}
                className="w-full p-4 border border-gray-200 rounded-xl hover:border-green-500 hover:bg-green-50 transition-all text-left group"
              >
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <p className="font-semibold text-gray-900">{test.label}</p>
                    <p className="text-sm text-gray-500 mt-1">{test.description}</p>
                    <p className="text-xs font-mono text-green-600 mt-2">{test.code}</p>
                  </div>
                  <ExternalLink className="w-5 h-5 text-gray-400 group-hover:text-green-600 transition-colors" />
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* Info */}
        <div className="mt-6 text-center">
          <p className="text-xs text-gray-500">
            Use test card number: <span className="font-mono">4000000000000002</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentLinkingTest;
